import welcomeBackLottie from "../../lottie/welcome_back.json"
import welcomeLottie from "../../lottie/welcome.json"
import welcomeGreenTickLottie from "../../lottie/welcomeGreenTick.json"

export const welcome = welcomeLottie;
export const welcomeBack = welcomeBackLottie;
export const welcomeGreenTick = welcomeGreenTickLottie;